import View from '../View';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const config = createIntegratedAtom({
  displayName: 'Order Confirmation Container',
  showEmpty: true,
  constraints: {
    pinToParent: true,
    parent: [{is: 'CommerceOrderConfirmationContainer', rule: 'ExactlyOne'}],
    wraps: ['CommerceOrderConfirmationHeaderWrapper'],
  },
  style: {
    base: {},
  },
  render: View,
  fields: {children: TListOfElement},
});

export default config;
